<template>
    <ProductCard :pointer="false">
        <div :class="{'tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-0 tw:md:gap-8': showWizard}">
            <div class="tw:order-2 tw:md-order-1">
                <ProductImage :imageSrc="item.image" :altText="item.title" :cover="true" />
                <ProductDescription :title="item.title" :description="item.description" :tags="item.tags" />
                <div v-if="item.courses && item.courses.length" class="tw:mt-4 tw:space-y-4">
                    <Course
                        v-for="(course, idx) in visibleCourses"
                        :course="course"
                        :item="item"
                        :idx="idx"
                        :key="course.id || idx"
                        :classId="item.classId"
                        :officeId="item.officeId"
                    />
                    <div v-if="item.courses.length > 1 && !selectedCourseId" class="tw:pt-2 tw:text-center">
                        <button
                            type="button"
                            class="tw:text-sm tw:font-medium tw:text-gray-700 tw:underline tw:underline-offset-2 hover:tw:text-gray-900 focus:tw:outline-none focus:tw:ring-2 focus:tw:ring-offset-2 focus:tw:ring-gray-300"
                            :aria-expanded="showAll"
                            @click="showAll = !showAll"
                        >
                            {{ showAll ? $t('Vis færre tider') : $t('Vis flere tider') }}
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="showWizard" class="tw:col-span-2 tw:order-1 tw:md:order-2 tw:mb-4 tw:md:mb-0">
                <InlineBookingWizard 
                    @close="close"
                />
            </div>
        </div>
    </ProductCard>
</template>

<script setup>
import { computed, ref } from "vue";
import ProductDescription from "./product/description.vue";
import ProductCard from "./product/cardWrapper.vue";
import ProductImage from "./product/image.vue";
import Course from './product-course.vue';
import InlineBookingWizard from './inlineBookingWizard.vue';
import { useWebShopStore } from "./webshopState";
const webShopState = useWebShopStore();

const selectedCourse = computed(() => webShopState.selectedCourse);

const selectedCourseId = computed(() => selectedCourse.value ? selectedCourse.value.course_id : null);

const { item, showWizard } = defineProps({
    item: { type: Object, required: true },
    showWizard: { type: Boolean, default: false },
});

const showAll = ref(false);

const visibleCourses = computed(() => {
    const courses = item?.courses.reduce((acc, curr) => {
            if (!acc.find((item) => item.course_id === curr.course_id)) {
                acc.push(curr);
            }
            return acc;
        }, []) ?? [];
    if (selectedCourseId.value) {
        // Show only selected course when one is selected
        return courses.filter(course => course.course_id === selectedCourseId.value);
    }
    return showAll.value ? courses : courses.slice(0, 1);
});
</script>

<style scoped></style>
